import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import type { PartsAndInventoryRouteFactory } from "./partsAndInventoryRouteContext";

const InventoryListScreen = lazyRouteComponent(
  () => import("../InventoryListScreen"),
  "InventoryListScreen",
);

export const createInventoryRoutes: PartsAndInventoryRouteFactory = ({
  context,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: context.basePath,
    component: InventoryListScreen,
  }),
];
